<template>
    <div class="grid min-h-dvh w-full grid-rows-[auto_1fr_auto] gap-6 bg-white">
        <header class="ds-grid sticky top-0 z-50 min-h-16 border-b border-ds-primary-200 bg-inherit">
            <div class="ds-grid-span-full flex items-center justify-between gap-2 py-3">
                <h1 class="text-heading-sm font-bold text-content-primary">{{ title }}</h1>
                <DsIconButton
                    ariaLabel="Close"
                    data-testid="close-button"
                    :href="closeButtonHref"
                    icon="fa-solid fa-xmark"
                    size="sm"
                    :to="closeButtonTo"
                    tooltipText="Close"
                    @click="$emit('close')"
                />
            </div>
        </header>
        <div class="ds-grid">
            <slot />
        </div>
        <footer class="ds-grid sticky bottom-0 z-50 min-h-16 border-t border-ds-primary-200 bg-inherit">
            <div class="ds-grid-span-full flex items-center gap-2 max-sm:flex-col max-sm:py-3">
                <DsButton
                    v-if="secondaryButtonText"
                    class="max-sm:order-1 max-sm:w-full"
                    :disabled="secondaryButtonDisabled"
                    size="md"
                    variant="secondary"
                    @click="$emit('secondaryButtonClick')"
                >
                    {{ secondaryButtonText }}
                </DsButton>
                <DsButton
                    class="max-sm:w-full sm:ml-auto"
                    :disabled="primaryButtonDisabled"
                    :href="primaryButtonHref"
                    :loading="primaryButtonLoading"
                    size="md"
                    variant="primary"
                    @click="$emit('primaryButtonClick')"
                >
                    {{ primaryButtonText }}
                </DsButton>
            </div>
        </footer>
    </div>
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import type { DsButtonProps } from '@/components/design-system/button/DsButton.vue';
import DsButton from '@/components/design-system/button/DsButton.vue';

export interface DsClosablePageProps {
    title: string;
    closeButtonTo?: DsButtonProps['to'];
    closeButtonHref?: DsButtonProps['href'];
    primaryButtonText: string;
    primaryButtonDisabled?: boolean;
    primaryButtonLoading?: boolean;
    primaryButtonHref?: DsButtonProps['href'];
    secondaryButtonText?: string;
    secondaryButtonDisabled?: boolean;
}

defineEmits<{
    close: [];
    primaryButtonClick: [];
    secondaryButtonClick: [];
}>();

defineProps<DsClosablePageProps>();
</script>
